module.exports = __webpack_public_path__ + "static/media/pre-2013.6913179d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/about/pre-2013.png
// module id = 593
// module chunks = 0